import React, { Component, useState } from "react";
import $ from "jquery";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import { Link } from "react-router-dom";
import Httpconfig from "../helpers/Httpconfig";
import styles from "react-responsive-carousel/lib/styles/carousel.min.css";
import Constant from "../../constants";
import { FormattedMessage } from "react-intl"; // Backup Way to Convert
import { I18nPropvider, LOCALES } from "../../i18nProvider";
import translate from "../../i18nProvider/translate";
import PatientHeader from "../patient/Patientheader";
import Patcss from "../../public/css/patient/order-medicine.css";
import PatientMenu from "../patient/Patientmenu";
import PatientSideMenu from "../patient/Patientsidemenu";
import PatientFooter from "../patient/Patientfooter";
import { reactLocalStorage } from "reactjs-localstorage";
import FileBase64 from "react-file-base64";
import * as SecureLS from "secure-ls";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});

const moment = require("moment");

const orderDetailsView = [];
const orderDetails = [];
const documentsRelated = [];

export default class Vieworders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_view_profile: true,
      selectedPatient: "",
      //  Prescriptions on the open order, each marked with whether the pharmacy
      //  has asked for it to be replaced. Without this the page said nothing at
      //  all about a re-upload request - only the email did.
      orderPrescriptions: [],
      reuploadRequired: false,
      reuploadReason: "",
    };
  }

  // To get detais after first render
  componentDidMount = () => {
    var lang = localStorage.getItem("Language_selected");
    if (lang != null) {
      if (this.state.Language != lang) {
        this.state.Language = lang;
        this.forceUpdate();
      }
    } else {
      this.state.Language = "en-us";
    }
    // var retrievedObject = localStorage.getItem("userObj");
    // let userObj = JSON.parse(retrievedObject);
    var retrievedObject = ls.get("userObjEnc");
    let userObj = retrievedObject;
    if (userObj == null) {
      window.location.href = "./patientLogin";
    }
    if (typeof userObj != undefined) {
      this.setState({
        name: userObj.name,
        user_mobile: userObj.mobile_number,
        email_id: userObj.email,
        token: userObj.accessToken,
        patientId: userObj.patient_id,
        profile_image: "",
      });
      this.forceUpdate();
    }

    this.getOrderDetails(userObj.patient_id);
    this.getProfileDetails(userObj.patient_id);
    const interval = setInterval(() => {
      //userObj.patient_id = 7;
      this.getOrderDetails(userObj.patient_id);
    }, 80000);
  };

  getProfileDetails = (patientId) => {
    if (patientId != "") {
      let url_path = "api/Patients/" + patientId;
      let patientDob = "";
      Httpconfig.httptokenget(Constant.siteurl + url_path, {}).then(
        (response) => {
          let patientDob = "";
          if (response.data.status == 200 && response.data.error == false) {
            let PatientGender = response?.data?.data[0]?.gender;
            let patientProfileImage = "";
            if (response?.data?.data[0]?.profile_pic != null) {
              patientProfileImage =
                Constant.imgurl + response?.data?.data[0]?.profile_pic;
            }
            // alert(patientProfileImage);
            this.setState({
              patientProfileImage: patientProfileImage,
              PatientGender: PatientGender,
            });
          }
        }
      );
    }
  };

  getPatientRelations = (patientId) => {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Patients/findpatientrealtives/" + patientId,
      {}
    )
      .then((response) => {
        /* Assiging consulation purpose to the state */
        let pName = "";
        let relationName = "";
        let selectedPatient = "";
        let id = "";
        let dataCount = Object.keys(response.data.data).length;
        for (let rel = 0; rel < dataCount; rel++) {
          if (response.data.data[rel].id != "") {
            id = response.data.data[rel].id;
            // alert(id);
          }
          if (response.data.data[rel].name != null) {
            pName = response.data.data[rel].name;
          }
          if (response.data.data[rel].master_relationship != null) {
            relationName =
              "(" +
              response.data.data[rel].master_relationship.relation_name +
              ")";
          }

          // alert(patientId+"=="+id);
          if (patientId == id) {
            // alert(selectedPatient);
            selectedPatient = pName + relationName;
          }
        }
        //  return selectedPatient;
        //  this.setState({
        //   selectedPatient:selectedPatient
        //  })
        this.state.selectedPatient = selectedPatient;
        $("#patientRelations").html(selectedPatient);

        this.forceUpdate();
      })

      .catch((error) => {
        toast.error(error);
      });
  };

  cancelCurrentOrder = (orderid, orderCreatedAt) => {
    //const anchor = e.target.closest("a");
    //let orderId = anchor.getAttribute("orderId");
    let appointmentCreatedAt = moment(orderCreatedAt);
    let mindiff = moment().diff(appointmentCreatedAt, "minutes");
    let constTime = Constant.orderCancelationTime.split(":");
    let totalCancelationMinutes =
      Number(constTime[0]) * 60 + Number(constTime[1]);
    if (mindiff <= totalCancelationMinutes) {
      let orderId = orderid;
      var isConfirm = window.confirm("Are you sure to Cancel the Order.");
      if (isConfirm) {
        Httpconfig.httptokenput(
          Constant.siteurl +
            "api/OM/orderProcess/retailerOrderStatus/" +
            orderId,
          {
            order_status: 6,
          }
        ).then((response) => {
          if (response.data.status == "200" && response.data.error == false) {
            toast.success(
              "Order Cancelled Successfully & Refund has been queued for processing.",
              {
                position: "bottom-center",
              }
            );
            // setTimeout(() => this.props.history.push("/patient/myOrders"), 2000);
            setTimeout(function() {
              window.location.href = "/myOrders";
            }, 2000);
          } else {
            toast.error(response.data.message, {
              //position: "bottom-center",
            });
          }
        });
      }
    } else {
      toast.error("Your cancellation time is over.", {
        //position: "bottom-center",
      });
    }
  };

  goBackPage = (e) => {
    $("#first_set").show();
    $(".profile_menu_sec1").show();
    this.setState({
      is_view_profile: true,
    });

    $("#second_set").hide();
  };

  // order_profile
  // order_view_det

  getCompleteOrderDetailsReload = () => {
    //alert("in");
    // const anchor = e.target.closest("a");
    let retailerId = this.state.retailerId; //anchor.getAttribute("retailerId");
    let orderId = this.state.selectedOrderId; //anchor.getAttribute("orderId");

    $(".profile_menu_sec").css("display", "none");
    $("#first_set").hide();
    let orderedQuantity = "";

    $(".profile_menu_sec1").hide();
    this.setState({
      is_view_profile: false,
      selectedOrderId: orderId,
    });

    $("#second_set").show();
    Httpconfig.httptokenpost(
      Constant.siteurl +
        "api/OM/orderProcess/getOrderDetailsweb" ,
         { "retailer_id": retailerId, "order_id": orderId }
        // retailerId +
        // "/" +
        // orderId
      // Constant.siteurl +
      //   "api/OM/orderProcess/getOrderDetails/" +
      //   retailerId +
      //   "/" +
      //   orderId
    ).then((response) => {
      if (response.data.status == "200" && response.data.error == false) {
        // console.log("response_ord", response);

        const orderDetails = response.data.data.map((orderDetails, num) => {
          console.log("checkType", typeof(orderDetails.order_status));
          let orderDate = "N/A";
          let updateDate = "N/A";
          let userOrderDate = "N/A";
          let total = "";
          orderDate = orderDetails.order_date;
          updateDate = orderDetails.updatedAt;
          let isPrescriptionImages = "0";
          let isPrescriptionImagesList = "0";
          this.setState({ cartId: response.data.data[0].cart_id });

          //  Taken from the API's per-document view rather than the block
          //  below, which reads cart_prescriptions_tbl (singular) - a key
          //  getOrderDetailsweb normalises away, so it never matches and this
          //  page has been showing no prescriptions at all.
          const firstOrder = response.data.data[0];
          this.setState({
            orderPrescriptions: firstOrder.prescriptions || [],
            reuploadRequired: !!firstOrder.reupload_prescription_required,
            reuploadReason: firstOrder.reupload_prescription_reason || "",
          });
          // alert(orderDetails.relative_id);
          this.getPatientRelations(orderDetails.relative_id);

          if (orderDetails.cart_prescriptions_tbl) {
            isPrescriptionImages = Object.keys(
              orderDetails.cart_prescriptions_tbl
            ).length;
            if (isPrescriptionImages > 0) {
              isPrescriptionImagesList = Object.keys(
                orderDetails.cart_prescriptions_tbl.medical_document
              ).length;
              // alert(isPrescriptionImagesList);
              this.setState({
                files: orderDetails.cart_prescriptions_tbl.medical_document,
              });
            }
          }

          let expectedDelivery = "N/A";
          let isRetailerData = Object.keys(
            orderDetails.retailer_registration_tbl
          ).length;
          if (isRetailerData > 0) {
            let slabDate =
              orderDetails.retailer_registration_tbl.set_delivery_days;
            if (slabDate) {
              // let orderDate = moment(orderDate).format("YYYY-MM-DD");
              var nowPlusOneDay = moment(orderDate).add("days", slabDate);
              expectedDelivery = nowPlusOneDay.format("YYYY-MM-DD");
              
            }
          }

          let newdate = orderDate
            .split("-")
            .reverse()
            .join("-");
          userOrderDate = moment(orderDate).format("dddd, MMMM Do YYYY");
          if(orderDetails.order_status == 5){
            expectedDelivery = "Order Delivered on "+moment(updateDate).format(
              "dddd, MMMM Do YYYY"
            );
          }else if(orderDetails.order_status == 6){
            expectedDelivery = "Order cancelled on "+moment(updateDate).format(
              "dddd, MMMM Do YYYY"
            );
          }else{
            expectedDelivery = "Expected delivery by"+moment(expectedDelivery).format(
              "dddd, MMMM Do YYYY"
            );
          }
          
          var retailerCurrency = "N/A";
          if (orderDetails.retailer_registration_tbl.currency) {
            retailerCurrency = orderDetails.retailer_registration_tbl.currency;
          }
          let orderMedicinesLength = orderDetails.order_processing_tbls.length;

          let deliveryAddressLength = Object.keys(
            orderDetails.delivery_address_tbl
          ).length;

          let relation_name = "Self";
          let deliveryAddress = "N/A";
          if (
            orderDetails.order_processing_tbls[0].retailer_stock_tbl[0]
              .discount == ""
          ) {
            orderDetails.order_processing_tbls[0].retailer_stock_tbl[0].discount = 0;
          }
          let price_discount =
            parseFloat(orderDetails.net_amount)
              .toFixed(2)
              .replace(/,/g, "") *
            parseFloat(
              orderDetails.order_processing_tbls[0].retailer_stock_tbl[0]
                .discount
            )
              .toFixed(2)
              .replace(/,/g, "");
          let Tot_discount = parseFloat(
            orderDetails.order_processing_tbls[0].retailer_stock_tbl[0].discount
          )
            .toFixed(2)
            .replace(/,/g, ""); //price_discount / 100;
          let coupanAmt =
            orderDetails.net_amount.replace(/,/g, "") - Tot_discount;
          let coupanTotal = (coupanAmt * orderDetails.coupan_value) / 100;
          if (orderMedicinesLength > 0) {
            const retailerOrderMedicineDetailsView = orderDetails.order_processing_tbls.map(
              (finalLoadedData, num) => {
                total =
                  parseFloat(finalLoadedData.amount.replace(/,/g, "")) *
                  parseFloat(finalLoadedData.quantity);
                orderedQuantity = finalLoadedData.quantity;
                return (
                  <div class="med_list">
                    <div class="med_name">
                    <div className="med_amount">
                      <h2>
                        {/* {num + 1}. */}
                        {" "}
                        {finalLoadedData.productMaster_b2c.medicinename}{" "}
                        {/* <span>{retailerCurrency} {finalLoadedData.productMaster_b2c.mrp}</span> */}
                      </h2>
                      <h4 class="mrp">
                          MRP:{retailerCurrency} {finalLoadedData.amount}
                        </h4>
                      <span>
                          {retailerCurrency}{" "}
                          {total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                        </span>
                      </div>
                      <h6>
                        {finalLoadedData.productMaster_b2c.manufacturer
                          ? finalLoadedData.productMaster_b2c.manufacturer
                          : ""}
                      </h6>
                      <p>
                        {finalLoadedData.productMaster_b2c.form
                          ? finalLoadedData.productMaster_b2c.form
                          : ""}
                      </p>
                      <p>
                        {finalLoadedData.productMaster_b2c.size
                          ? finalLoadedData.productMaster_b2c.size
                          : ""}
                      </p>
                      <h6>
                        {orderedQuantity
                          ? "Ordered Quantity: " + orderedQuantity
                          : ""}
                      </h6>
                      {}
                    </div>
                  </div>
                );
              }
            );
            this.setState({
              retailerOrderMedicineDetailsView: retailerOrderMedicineDetailsView,
            });
          }

          let progressBar = "";

          if (orderDetails.order_status === 1) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">2</a> <p class="p_light">Prescription Verified </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">3</a><p class="p_light">Processed </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">4</a><p class="p_light">Shipped</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">5</a><p class="p_light">Delivered</p></div></div>';
          } else if (orderDetails.order_status === 2) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Prescription Verified </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Processed </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">3</a><p class="p_light">Shipped</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">4</a><p class="p_light">Delivered</p></div></div>';
          } else if (orderDetails.order_status === 3) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Prescription Verified </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Processed </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle"></a><p class="p_light">Shipped</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">4</a><p class="p_light">Delivered</p></div></div>';
          } else if (orderDetails.order_status === 4) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Prescription Verified </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Processed </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Shipped</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle"></a><p class="p_light">Delivered</p></div></div>';
          } else if (orderDetails.order_status === 5) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Prescription Verified </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Processed </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Shipped</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Delivered</p></div></div>';
          } else if (orderDetails.order_status === 6) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_light">Cancelled </p></div></div>';
          }
          let appointmentCreatedAt = moment(orderDetails.order_date);
          let mindiff = moment().diff(appointmentCreatedAt, "minutes");
          let constTime = Constant.orderCancelationTime.split(":");
          let totalCancelationMinutes =
            Number(constTime[0]) * 60 + Number(constTime[1]);

          return (
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12">
                  <div class="back_head" onClick={this.goBackPage.bind(this)}>
                    <h2>
                     <img src="../images/patient/img/arrow-back.svg" />
                      Back to Order List
                    </h2>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="order_det_list">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="order_det_head">
                          <div class="presc_img">
                            {/* <img src="../images/patient/img/Ordermedicine/pdf.svg" /> */}
                            {orderDetails.invoice ? (
                              <a
                                href={
                                  orderDetails.invoice
                                    ? Constant.imgurl + orderDetails.invoice
                                    : ""
                                }
                                target="_blank"
                              >
                                <img src="../images/patient/img/Ordermedicine/pdf.svg" />
                              </a>
                            ) : (
                              ""
                            )}
                          </div>
                          <div class="presc_det">
                            <h2>
                              Order ID: <span>{orderDetails.id}</span>
                            </h2>
                            <h2>
                              Order Date: <span>{userOrderDate}</span>
                            </h2>
                          </div>
                          {orderDetails.order_status == 1 ? (
                            <p class="pending_btns verify_btn">
                              Prescription verification pending..
                            </p>
                          ) : (
                            ""
                          )}
                          {orderDetails.order_status == 2 ? (
                            <p class="verify_btn">Prescription verified</p>
                          ) : (
                            ""
                          )}
                          {orderDetails.order_status == 3 ? (
                            <p class="verify_btn">Processed</p>
                          ) : (
                            ""
                          )}
                          {orderDetails.order_status == 4 ? (
                            <p class="verify_btn">Shipped</p>
                          ) : (
                            ""
                          )}
                          {orderDetails.order_status == 5 ? (
                            <p class="verify_btn">Delivered</p>
                          ) : (
                            ""
                          )}
                          {orderDetails.order_status == 6 &&
                          orderDetails.refund_status == 6 ? (
                            <p class="pending_btns verify_btn">
                              Cancelled : <br />
                              Refund Queued For Processing..
                            </p>
                          ) : orderDetails.order_status == 6 &&
                            orderDetails.refund_status == 7 ? (
                            <p class="pending_btns verify_btn ">
                              Cancelled : <br /> Amount Refunded
                            </p>
                          ) : orderDetails.order_status == 6 ? (
                            <p class="pending_btns verify_btn">Cancelled </p>
                          ) : (
                            ""
                          )}
                          {/* {orderDetails.order_status!=5 ?
                          orderDetails.invoice ? (
                            <p class="verify_btn">Invoice Generated</p>
                          ) : (
                            <p class="verify_btn">
                              Prescription verification pending..
                            </p>
                          ) : <p class="verify_btn"> 
                          Cancelled
                        </p>
                          } */}
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-6">
                        <div class="delivery_det">
                          <div class="expect_head">
                            <h2>{expectedDelivery}</h2>
                            <h6>
                              You will received an invoice with order details
                              after verified the prescription by our pharmacy
                            </h6>
                          </div>
                          <div class="expect_wizard">
                            <div class="stepwizard">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: progressBar,
                                }}
                              />
                            </div>
                          </div>
                          <div class="retailer_address">
                            <React.Fragment>
                              <h4>
                                {
                                  orderDetails.retailer_registration_tbl
                                    .account_holder_name
                                }
                              </h4>
                              <p>
                                {orderDetails.retailer_registration_tbl.address}
                              </p>
                              {/* <p>
                                {
                                  userdata.address ? userdata.address : ""
                                  // orderDetails.patient_tbl
                                  //   .delivery_address_tbls[0].address ? orderDetails.patient_tbl
                                  //   .delivery_address_tbls[0].address :"--"
                                }
                                <br />
                                {
                                  userdata.location ? userdata.location : ""
                                  // orderDetails.patient_tbl
                                  //   .delivery_address_tbls[0].location
                                }
                                <br />
                                {
                                  userdata.landmark ? userdata.landmark : ""
                                  // orderDetails.patient_tbl
                                  //   .delivery_address_tbls[0].landmark
                                }
                              </p> */}
                            </React.Fragment>
                          </div>
                          <div class="delivery_address">
                            <h2>Delivery Address</h2>
                            {orderDetails.delivery_address_tbl ? (
                              // ? orderDetails.patient_tbl.delivery_address_tbls.map(
                              //   (userdata, num) => {
                              //     return (
                              <React.Fragment>
                                <h4>
                                  {orderDetails.delivery_address_tbl.name
                                    ? orderDetails.delivery_address_tbl.name
                                    : // : orderDetails.patient_tbl
                                      //   .delivery_address_tbls[0].name
                                      //   ? orderDetails.patient_tbl
                                      //     .delivery_address_tbls[0].name
                                      "--"}
                                </h4>
                                <p>
                                  {orderDetails.delivery_address_tbl.address
                                    ? orderDetails.delivery_address_tbl.address
                                    : ""
                                  // orderDetails.patient_tbl
                                  //   .delivery_address_tbls[0].address ? orderDetails.patient_tbl
                                  //   .delivery_address_tbls[0].address :"--"
                                  }
                                  <br />
                                  {orderDetails.delivery_address_tbl.location
                                    ? orderDetails.delivery_address_tbl.location
                                    : ""
                                  // orderDetails.patient_tbl
                                  //   .delivery_address_tbls[0].location
                                  }
                                  <br />
                                  {orderDetails.delivery_address_tbl.landmark
                                    ? orderDetails.delivery_address_tbl.landmark
                                    : ""
                                  // orderDetails.patient_tbl
                                  //   .delivery_address_tbls[0].landmark
                                  }
                                </p>
                              </React.Fragment>
                            ) : (
                              // );
                              //   }
                              // )
                              ""
                            )}
                          </div>
                          <div class="delivery_presc">
                            {this.renderReuploadNotice()}
                            <div class="presc_head">
                              <div class="presc_img">
                                <img src="../images/patient/img/Ordermedicine/upload_icon.png" />
                              </div>
                              <div class="presc_det">
                                <h2>UPLOAD &amp; SEND PRESCRIPTION</h2>
                                <h6>You have one Rx medicine in the item</h6>
                              </div>
                            </div>
                            <div class="delivery_upload_img">
                              {/* <div class=""> */}
                              {isPrescriptionImagesList > 0
                                ? orderDetails.cart_prescriptions_tbl.medical_document.map(
                                    (presImages, num) => {
                                      return (
                                        <div className="upload_presc_img consult_doctor_banner">
                                          <a
                                            href={
                                              presImages
                                                ? Constant.imgurl + presImages
                                                : ""
                                            }
                                            target="_blank"
                                          >
                                            <img
                                              src={Constant.imgurl + presImages}
                                            />
                                            {/* <img src="https://icon-library.com/images/prescription-icon/prescription-icon-18.jpg" /> */}
                                          </a>

                                          <img
                                            class="delete_img"
                                            id={presImages}
                                            onClick={this.removeImageOnClick}
                                            src="../images/patient/img/Ordermedicine/delete.png"
                                          />
                                        </div>
                                      );
                                    }
                                  )
                                : ""}
                              {/* </div> */}
                              {/* <img src="https://icon-library.com/images/prescription-icon/prescription-icon-18.jpg" /> */}
                            </div>
                            <div class="delivery_upload_btn">
                              <div class="custom-file-upload">
                                {orderDetails.order_status == 1 ? (
                                  <label>
                                    Upload
                                    {/* <p>or Drag &amp; Drop here</p> */}
                                    <FileBase64
                                      multiple={true}
                                      onDone={this.getFiles.bind(this)}
                                    />
                                  </label>
                                ) : (
                                  ""
                                )}
                                {/* <label
                                  for="file-upload"
                                  class="custom-file-upload1"
                                >
                                  Upload
                                <p>or Drag &amp; Drop here</p>
                                 <input id="file-upload" type="file" /> 
                                <FileBase64
                    multiple={true}
                  onDone={this.getFiles.bind(this)}
                    />
                                </label> */}

                                {/* <div class="ret_upload_img">
                                  <h2>
                                    this is image{this.state.prescriptionImage}
                                  </h2>
                                  {
                                    this.state.prescriptionImage ? (
                                      <img
                                        id="uploded-pres"
                                        src={this.state.prescriptionImage}
                                      />
                                    ) : (
                                      ""
                                    )
                                    // <img src="https://icon-library.com/images/prescription-icon/prescription-icon-18.jpg" />
                                  }
                                  {documentsRelated ? documentsRelated : ""}

                                  {this.state.uploadedImages
                                    ? this.state.uploadedImages
                                    : ""}
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="payment_det">
                          <div class="pay_head">
                            <h2>Products & Payment details</h2>
                            <p>
                              Medicines for{" "}
                              <span id="patientRelations">
                                {this.state.selectedPatient
                                  ? this.state.selectedPatient
                                  : ""}
                              </span>
                              {/* <span>{orderDetails.patient_tbl.name.charAt(0).toUpperCase() +
                                  orderDetails.patient_tbl.name.slice(1)} ({relation_name})</span> */}
                            </p>
                          </div>
                          <div class="medicine_sec">
                            {this.state.retailerOrderMedicineDetailsView}
                          </div>
                          <div class="price_det_head">
                            <h2>Price details</h2>
                          </div>
                          <div class="pay_list">
                            <p>
                              {/* Total M.R.P. ({orderedQuantity} x {retailerCurrency} {orderDetails.amount}){" "} */}
                              Total M.R.P.{" "}
                              <span class="tot_amnt">
                                {retailerCurrency}{" "}
                                {parseFloat(orderDetails.net_amount)
                                  .toFixed(2)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                              </span>
                            </p>
                            <p>
                              Coupon code applied (
                              {orderDetails.coupan_value
                                ? orderDetails.coupan_value + "%"
                                : "0"}
                              ) :
                              <span>
                                {/* - {retailerCurrency}{" "} */}
                                {retailerCurrency}{" "}
                                {coupanTotal
                                  ? parseFloat(coupanTotal)
                                      .toFixed(2)
                                      .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                                  : "0"}
                              </span>
                            </p>
                            <p>
                              Delivery Charges
                              <span>
                                + {retailerCurrency}{" "}
                                {orderDetails.delivery_charges
                                  ? parseFloat(orderDetails.delivery_charges)
                                      .toFixed(2)
                                      .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                                  : "0.00"}
                              </span>
                            </p>
                          </div>
                          <h4 class="total_payable">
                            Discount{" "}
                            <span>
                              {/* {orderDetails.total_paid &&
                                    orderDetails.payable_amount
                                    ? retailerCurrency +
                                    " " +
                                    (
                                      parseFloat(
                                        orderDetails.payable_amount
                                      ) - parseFloat(orderDetails.total_paid)
                                    )
                                      .toFixed(2)
                                      .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                                    : "0.00"} */}
                              {/* {orderDetails.order_processing_tbls[0]
                                .retailer_stock_tbl[0].discount
                                ? parseFloat(
                                    orderDetails.order_processing_tbls[0]
                                      .retailer_stock_tbl[0].discount
                                  )
                                    .toFixed(2)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                                : "0.00"} */}
                              {parseFloat(Tot_discount)
                                .toFixed(2)
                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                            </span>
                          </h4>
                          <h4 class="total_payable">
                            Total Paid Amount{" "}
                            <span>
                              {orderDetails.payable_amount
                                ? retailerCurrency +
                                  " " +
                                  parseFloat(orderDetails.payable_amount)
                                    .toFixed(2)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                                : "0.00"}
                            </span>
                          </h4>

                          {orderDetails.order_status > 2 ? (
                            <React.Fragment>
                              <h4 class="total_payable">
                                Billed Amount{" "}
                                <span>
                                  {orderDetails.total_paid
                                    ? retailerCurrency +
                                      " " +
                                      parseFloat(orderDetails.total_paid)
                                        .toFixed(2)
                                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                                    : "0.00"}
                                </span>
                              </h4>
                            </React.Fragment>
                          ) : (
                            ""
                          )}

                          <div class="pay_mode">
                            <h2>Payment Mode</h2>
                            <h3>
                              Paid Through :
                              <span>
                                {orderDetails.payment_mode
                                  ? orderDetails.payment_mode
                                  : "Card"}
                              </span>
                            </h3>
                          </div>
                          <div>
                            <a
                              orderId={orderDetails.id}
                              retailerId={orderDetails.retailer_id}
                              href="javascript:void(0);"
                              onClick={this.cancelCurrentOrder.bind(
                                this,
                                orderDetails.id,
                                orderDetails.order_date
                              )}
                            >
                              {" "}
                              {orderDetails.order_status != 5 &&
                              orderDetails.order_status != 6 &&
                              mindiff <= totalCancelationMinutes &&
                              orderDetails.order_status != 4 ? (
                                <p class="cancel_txt">Cancel Order</p>
                              ) : (
                                ""
                              )}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        });
        this.state.orderDetails = "";
        this.forceUpdate();
        this.setState({
          orderDetails: orderDetails,
        });
      }
    });
  };

  getCompleteOrderDetails = (e) => {
    const anchor = e.target.closest("a");

    let retailerId = anchor.getAttribute("retailerId");
    let orderId = anchor.getAttribute("orderId");
    $(".profile_menu_sec").css("display", "none");
    $("#first_set").hide();
    let orderedQuantity = "";

    $(".profile_menu_sec1").hide();
    this.setState({
      is_view_profile: false,
      selectedOrderId: orderId,
      retailerId: retailerId,
    });

    $("#second_set").show();
    Httpconfig.httptokenpost(
      Constant.siteurl +
        // "api/OM/orderProcess/getOrderDetails/" +
        // retailerId +
        // "/" +
        // orderId
         "api/OM/orderProcess/getOrderDetailsweb" ,
         { "retailer_id": retailerId, "order_id": orderId }
    ).then((response) => {
      if (response.data.status == "200" && response.data.error == false) {
        const orderDetails = response.data.data.map((orderDetails, num) => {
          let orderDate = "N/A";
          let updateDate = "N/A";
          let userOrderDate = "N/A";
          let total = "";
          orderDate = orderDetails.order_date;
          updateDate = orderDetails.updatedAt;
          let isPrescriptionImages = "0";
          let isPrescriptionImagesList = "0";
          this.setState({ cartId: response.data.data[0].cart_id });

          //  Taken from the API's per-document view rather than the block
          //  below, which reads cart_prescriptions_tbl (singular) - a key
          //  getOrderDetailsweb normalises away, so it never matches and this
          //  page has been showing no prescriptions at all.
          const firstOrder = response.data.data[0];
          this.setState({
            orderPrescriptions: firstOrder.prescriptions || [],
            reuploadRequired: !!firstOrder.reupload_prescription_required,
            reuploadReason: firstOrder.reupload_prescription_reason || "",
          });
          // alert(orderDetails.relative_id);
          this.getPatientRelations(orderDetails.relative_id);

          if (orderDetails.cart_prescriptions_tbl) {
            isPrescriptionImages = Object.keys(
              orderDetails.cart_prescriptions_tbl
            ).length;
            if (isPrescriptionImages > 0) {
              isPrescriptionImagesList = Object.keys(
                orderDetails.cart_prescriptions_tbl.medical_document
              ).length;
              // alert(isPrescriptionImagesList);
              this.setState({
                files: orderDetails.cart_prescriptions_tbl.medical_document,
              });
            }
          }

          let expectedDelivery = "N/A";
          let isRetailerData = Object.keys(
            orderDetails.retailer_registration_tbl
          ).length;

          if (isRetailerData > 0) {
            let slabDate =
              orderDetails.retailer_registration_tbl.set_delivery_days;
            if (slabDate) {
              // let orderDate = moment(orderDate).format("YYYY-MM-DD");
              var nowPlusOneDay = moment(orderDate).add("days", slabDate);
              expectedDelivery = nowPlusOneDay.format("YYYY-MM-DD");
            }
          }

          let newdate = orderDate
            .split("-")
            .reverse()
            .join("-");
          userOrderDate = moment(orderDate).format("dddd, MMMM Do YYYY");
          if(orderDetails.order_status == 6){
            expectedDelivery = "Order cancelled on "+moment(updateDate).format(
              "dddd, MMMM Do YYYY"
            );
          }else if(orderDetails.order_status == 5){
            expectedDelivery = "Order delivered on "+moment(expectedDelivery).format(
              "dddd, MMMM Do YYYY"
            );
          }else{
            expectedDelivery = "Expected delivery by "+moment(expectedDelivery).format(
              "dddd, MMMM Do YYYY"
            );
          }
          
          var retailerCurrency = "N/A";
          if (orderDetails.retailer_registration_tbl.currency) {
            retailerCurrency = orderDetails.retailer_registration_tbl.currency;
          }
          let orderMedicinesLength = orderDetails.order_processing_tbls.length;

          let deliveryAddressLength = Object.keys(
            orderDetails.delivery_address_tbl
          ).length;

          let relation_name = "Self";
          let deliveryAddress = "N/A";
          if(orderDetails.order_processing_tbls[0].retailer_stock_tbl.length > 0){
          if (
           orderDetails.order_processing_tbls[0].retailer_stock_tbl[0].discount == ""
          ) {
            orderDetails.order_processing_tbls[0].retailer_stock_tbl[0].discount = 0;
          }
        }
          let price_discount =
            parseFloat(orderDetails.net_amount)
              .toFixed(2)
              .replace(/,/g, "") *
            parseFloat(
              orderDetails.order_processing_tbls[0].retailer_stock_tbl.length > 0 ? orderDetails.order_processing_tbls[0].retailer_stock_tbl[0]
                .discount : 0
            )
              .toFixed(2)
              .replace(/,/g, "");
          let Tot_discount = parseFloat(orderDetails.discount)
            .toFixed(2)
            .replace(/,/g, ""); //price_discount / 100;
          let coupanAmt =
            orderDetails.net_amount.replace(/,/g, "") - Tot_discount;
          if (orderDetails?.coupan_value != "") {
            orderDetails.coupan_value = orderDetails?.coupan_value?.replace(
              /%/g,
              ""
            );
          }

          // let coupanTotal = (coupanAmt * orderDetails.coupan_value) / 100;
          let coupanTotal = orderDetails.coupon_amount
            ? orderDetails.coupon_amount
            : "0.00";

          if (orderMedicinesLength > 0) {
            const retailerOrderMedicineDetailsView = orderDetails.order_processing_tbls.map(
              (finalLoadedData, num) => {
                total = finalLoadedData.amount
                  ? parseFloat(finalLoadedData.amount.replace(/,/g, "")) *
                    parseFloat(finalLoadedData.quantity)
                  : "";

                orderedQuantity = finalLoadedData.quantity;
                return (
                  <div class="med_list">
                    <div class="med_name">
                    <div className="med_amount">
                      <span> {num + 1}.</span>
                      <h2>
                       {" "}
                        {finalLoadedData.productMaster_b2c.medicinename}{" "}
                        </h2>
                        <h4 class="mrp">
                          MRP:{retailerCurrency} {finalLoadedData.amount}
                        </h4>
                        <h5>
                          {retailerCurrency}{" "}
                          {total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                        </h5>
                     </div>
                     <div className="order_descp">
                      <h6>
                        {finalLoadedData.productMaster_b2c.manufacturer
                          ? finalLoadedData.productMaster_b2c.manufacturer
                          : ""}
                      </h6>
                      <p>
                        {finalLoadedData.productMaster_b2c.product_form
                          ? finalLoadedData.productMaster_b2c.product_form
                          : ""}
                      </p>
                      <p>
                        {finalLoadedData.productMaster_b2c.packing_details
                          ? finalLoadedData.productMaster_b2c.packing_details
                          : ""}
                      </p>
                      <h6>
                        {orderedQuantity
                          ? "Ordered Quantity: " + orderedQuantity
                          : ""}
                      </h6>
                      </div>
                      {}
                    </div>
                  </div>
                );
              }
            );

            this.setState({
              retailerOrderMedicineDetailsView: retailerOrderMedicineDetailsView,
            });
          }

          let progressBar = "";

          if (orderDetails.order_status === 1) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">2</a> <p class="p_light">Prescription Verified </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">3</a><p class="p_light">Processed </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">4</a><p class="p_light">Shipped</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">5</a><p class="p_light">Delivered</p></div></div>';
          } else if (orderDetails.order_status === 2) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Prescription Verified </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Processed </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">3</a><p class="p_light">Shipped</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">4</a><p class="p_light">Delivered</p></div></div>';
          } else if (orderDetails.order_status === 3) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Prescription Verified </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Processed </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle"></a><p class="p_light">Shipped</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">4</a><p class="p_light">Delivered</p></div></div>';
          } else if (orderDetails.order_status === 4) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Prescription Verified </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Processed </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Shipped</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle"></a><p class="p_light">Delivered</p></div></div>';
          } else if (orderDetails.order_status === 5) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Prescription Verified </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Processed </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Shipped</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Delivered</p></div></div>';
          } else if (orderDetails.order_status === 6) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_light">Cancelled </p></div></div>';
          }
          let orderCreatedAt = moment(orderDetails.order_date);
          let mindiff = moment().diff(orderCreatedAt, "minutes");
          let constTime = Constant.orderCancelationTime.split(":");
          let totalCancelationMinutes =
            Number(constTime[0]) * 60 + Number(constTime[1]);
          console.log("mindiff", mindiff);
          console.log("totalCancelationMinutes", totalCancelationMinutes);
          console.log("checkType", typeof(orderDetails.order_status));
          return (
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12">
                  <div class="back_head" onClick={this.goBackPage.bind(this)}>
                    <h2>
                    <img src="../images/patient/img/arrow-back.svg" />
                      Back to Order List
                    </h2>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="order_det_list">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="order_det_head">
                          <div class="presc_img">
                            {/* <img src="../images/patient/img/Ordermedicine/pdf.svg" /> */}
                            {orderDetails.invoice ? (
                              <a
                                href={
                                  orderDetails.invoice
                                    ? Constant.imgurl + orderDetails.invoice
                                    : ""
                                }
                                target="_blank"
                              >
                                <img src="../images/patient/img/Ordermedicine/pdf.svg" />
                              </a>
                            ) : (
                              ""
                            )}
                          </div>
                          <div class="presc_det">
                            <h2>
                              Order ID: <span>{orderDetails.id}</span>
                            </h2>
                            <h2>
                              Order Date: <span>{userOrderDate}</span>
                            </h2>
                          </div>
                          {orderDetails.order_status == 1 ? (
                            <p class="pending_btns verify_btn">
                              Prescription verification pending..
                            </p>
                          ) : (
                            ""
                          )}
                          {orderDetails.order_status == 2 ? (
                            <p class="verify_btn">Prescription verified</p>
                          ) : (
                            ""
                          )}
                          {orderDetails.order_status == 3 ? (
                            <p class="verify_btn">Processed</p>
                          ) : (
                            ""
                          )}
                          {orderDetails.order_status == 4 ? (
                            <p class="verify_btn">Shipped</p>
                          ) : (
                            ""
                          )}
                          {orderDetails.order_status == 5 ? (
                            <p class="verify_btn">Delivered</p>
                          ) : (
                            ""
                          )}
                          {orderDetails.order_status == 6 &&
                          orderDetails.refund_status == 6 ? (
                            <p class="pending_btns verify_btn">
                              Cancelled : <br />
                              Refund Queued For Processing..
                            </p>
                          ) : orderDetails.order_status == 6 &&
                            orderDetails.refund_status == 7 ? (
                            <p class="pending_btns verify_btn ">
                              Cancelled : <br /> Amount Refunded
                            </p>
                          ) : orderDetails.order_status == 6 ? (
                            <p class="pending_btns verify_btn">Cancelled </p>
                          ) : (
                            ""
                          )}
                          {/* {orderDetails.order_status!=5 ?
                          orderDetails.invoice ? (
                            <p class="verify_btn">Invoice Generated</p>
                          ) : (
                            <p class="verify_btn">
                              Prescription verification pending..
                            </p>
                          ) : <p class="verify_btn"> 
                          Cancelled
                        </p>
                          } */}
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-6">
                        <div class="delivery_det">
                          <div class="expect_head">
                            <h2>{expectedDelivery}</h2>
                            <h6>
                              You will received an invoice with order details
                              after verified the prescription by our pharmacy
                            </h6>
                          </div>
                          <div class="expect_wizard">
                            <div class="stepwizard">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: progressBar,
                                }}
                              />
                            </div>
                          </div>
                          <div class="retailer_address">
                            <React.Fragment>
                              <h4>
                                {
                                  orderDetails.retailer_registration_tbl
                                    .storename
                                }
                              </h4>
                              <p>
                                {orderDetails.retailer_registration_tbl.address}
                              </p>
                              {/* <p>
                                {
                                  userdata.address ? userdata.address : ""
                                  // orderDetails.patient_tbl
                                  //   .delivery_address_tbls[0].address ? orderDetails.patient_tbl
                                  //   .delivery_address_tbls[0].address :"--"
                                }
                                <br />
                                {
                                  userdata.location ? userdata.location : ""
                                  // orderDetails.patient_tbl
                                  //   .delivery_address_tbls[0].location
                                }
                                <br />
                                {
                                  userdata.landmark ? userdata.landmark : ""
                                  // orderDetails.patient_tbl
                                  //   .delivery_address_tbls[0].landmark
                                }
                              </p> */}
                            </React.Fragment>
                          </div>
                          <div class="delivery_address">
                            <h2>Delivery Address</h2>
                            {orderDetails.delivery_address_tbl ? (
                              // ? orderDetails.patient_tbl.delivery_address_tbls.map(
                              //   (userdata, num) => {
                              //     return (
                              <React.Fragment>
                                <h4>
                                  {orderDetails.delivery_address_tbl.name
                                    ? orderDetails.delivery_address_tbl.name
                                    : // : orderDetails.patient_tbl
                                      //   .delivery_address_tbls[0].name
                                      //   ? orderDetails.patient_tbl
                                      //     .delivery_address_tbls[0].name
                                      "--"}
                                </h4>
                                <p>
                                  {orderDetails.delivery_address_tbl.address
                                    ? orderDetails.delivery_address_tbl.address
                                    : ""
                                  // orderDetails.patient_tbl
                                  //   .delivery_address_tbls[0].address ? orderDetails.patient_tbl
                                  //   .delivery_address_tbls[0].address :"--"
                                  }
                                  {/* <br />
                                  {
                                    orderDetails.delivery_address_tbl.location
                                      ? orderDetails.delivery_address_tbl
                                          .location
                                      : ""
                               
                                  } */}
                                  <br />
                                  {orderDetails.delivery_address_tbl.landmark
                                    ? orderDetails.delivery_address_tbl.landmark
                                    : ""
                                  // orderDetails.patient_tbl
                                  //   .delivery_address_tbls[0].landmark
                                  }
                                  <br />
                                  {orderDetails.delivery_address_tbl.zipcode
                                    ? orderDetails.delivery_address_tbl.zipcode
                                    : ""
                                  // orderDetails.patient_tbl
                                  //   .delivery_address_tbls[0].landmark
                                  }
                                  <br />
                                  <span>Mobile :</span>
                                  {orderDetails.delivery_address_tbl.mobile_no
                                    ? orderDetails.delivery_address_tbl
                                        .mobile_no
                                    : ""
                                  // orderDetails.patient_tbl
                                  //   .delivery_address_tbls[0].landmark
                                  }
                                </p>
                              </React.Fragment>
                            ) : (
                              // );
                              //   }
                              // )
                              ""
                            )}
                          </div>
                          <div class="delivery_presc">
                            {this.renderReuploadNotice()}
                            <div class="presc_head">
                              <div class="presc_img">
                                <img src="../images/patient/img/Ordermedicine/upload_icon.png" />
                              </div>
                              <div class="presc_det">
                                <h2>UPLOAD &amp; SEND PRESCRIPTION</h2>
                                <h6>You have one Rx medicine in the item</h6>
                              </div>
                            </div>
                            <div class="delivery_upload_img">
                              {/* <div class="upload_top_img"> */}
                              {isPrescriptionImagesList > 0
                                ? orderDetails.cart_prescriptions_tbl.medical_document.map(
                                    (presImages, num) => {
                                      return (
                                        <div className="upload_presc_img consult_doctor_banner">
                                          <a
                                            href={
                                              presImages
                                                ? Constant.imgurl + presImages
                                                : ""
                                            }
                                            target="_blank"
                                          >
                                            <img
                                              src={Constant.imgurl + presImages}
                                            />
                                            {/* <img src="https://icon-library.com/images/prescription-icon/prescription-icon-18.jpg" /> */}
                                          </a>

                                          <img
                                            class="delete_img"
                                            id={presImages}
                                            onClick={this.removeImageOnClick}
                                            src="../images/patient/img/Ordermedicine/delete.png"
                                          />
                                        </div>
                                      );
                                    }
                                  )
                                : ""}
                              {/* </div> */}
                              {/* <img src="https://icon-library.com/images/prescription-icon/prescription-icon-18.jpg" /> */}
                            </div>
                            {orderDetails.order_status == 1 ? (
                              <div class="delivery_upload_btn">
                                <div class="custom-file-upload">
                                  <label>
                                    Upload
                                    {/* <p>or Drag &amp; Drop here</p> */}
                                    <FileBase64
                                      multiple={true}
                                      onDone={this.getFiles.bind(this)}
                                    />
                                  </label>

                                  {/* <label
                                  for="file-upload"
                                  class="custom-file-upload1"
                                >
                                  Upload
                                <p>or Drag &amp; Drop here</p>
                                 <input id="file-upload" type="file" /> 
                                <FileBase64
                    multiple={true}
                  onDone={this.getFiles.bind(this)}
                    />
                                </label> */}

                                  {/* <div class="ret_upload_img">
                                  <h2>
                                    this is image{this.state.prescriptionImage}
                                  </h2>
                                  {
                                    this.state.prescriptionImage ? (
                                      <img
                                        id="uploded-pres"
                                        src={this.state.prescriptionImage}
                                      />
                                    ) : (
                                      ""
                                    )
                                    // <img src="https://icon-library.com/images/prescription-icon/prescription-icon-18.jpg" />
                                  }
                                  {documentsRelated ? documentsRelated : ""}

                                  {this.state.uploadedImages
                                    ? this.state.uploadedImages
                                    : ""}
                                </div> */}
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="payment_det">
                          <div class="pay_head">
                            <h2>Products & Payment details</h2>
                            <p>
                              Medicines for{" "}
                              <span id="patientRelations">
                                {this.state.selectedPatient
                                  ? this.state.selectedPatient
                                  : ""}
                              </span>
                              {/* <span>{orderDetails.patient_tbl.name.charAt(0).toUpperCase() +
                                  orderDetails.patient_tbl.name.slice(1)} ({relation_name})</span> */}
                            </p>
                          </div>
                          <div class="medicine_sec">
                            {this.state.retailerOrderMedicineDetailsView}
                          </div>
                          <div class="price_det_head">
                            <h2>Price details</h2>
                          </div>
                          <div class="pay_list">
                            <p>
                              {/* Total M.R.P. ({orderedQuantity} x {retailerCurrency} {orderDetails.amount}){" "} */}
                              Total M.R.P.{" "}
                              <span class="tot_amnt">
                                {retailerCurrency}{" "}
                                {parseFloat(orderDetails.net_amount)
                                  .toFixed(2)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                              </span>
                            </p>
                            <p>
                              Coupon Discount (-) :
                              <span>
                                {/* - {retailerCurrency}{" "} */}
                                {retailerCurrency}{" "}
                                {coupanTotal
                                  ? parseFloat(coupanTotal)
                                      .toFixed(2)
                                      .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                                  : "0"}
                              </span>
                            </p>
                            <p>
                              Delivery Charges
                              <span>
                                + {retailerCurrency}{" "}
                                {orderDetails.delivery_charges
                                  ? parseFloat(orderDetails.delivery_charges)
                                      .toFixed(2)
                                      .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                                  : "0.00"}
                              </span>
                            </p>
                          </div>
                          <h4 class="total_payable">
                            Discount{" "}
                            <span>
                            {retailerCurrency}{" "}
                              {parseFloat(Tot_discount)
                                .toFixed(2)
                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                            </span>
                          </h4>
                          <h4 class="total_payable">
                            Total Paid Amount{" "}
                            <span>
                              {orderDetails.payable_amount
                                ? retailerCurrency +
                                  " " +
                                  parseFloat(orderDetails.payable_amount)
                                    .toFixed(2)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                                : "0.00"}
                            </span>
                          </h4>
                          {/* 
                          {orderDetails.order_status > 2 ? (
                            <React.Fragment>
                              <h4 class="total_payable">
                                Billed Amount{" "}
                                <span>
                                  {orderDetails.total_paid
                                    ? retailerCurrency +
                                    " " +
                                    parseFloat(orderDetails.total_paid)
                                      .toFixed(2)
                                      .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                                    : "0.00"}
                                </span>
                              </h4>
                            </React.Fragment>
                          ) : (
                            ""
                          )} */}

                          <div class="pay_mode">
                            <h2>Payment Mode</h2>
                            <h3>
                              Paid Through :
                              <span>
                                {orderDetails.payment_mode
                                  ? orderDetails.payment_mode
                                  : "Online"}
                              </span>
                            </h3>
                          </div>
                          <div>
                            <a
                              orderId={orderDetails.id}
                              retailerId={orderDetails.retailer_id}
                              href="javascript:void(0);"
                              onClick={this.cancelCurrentOrder.bind(
                                this,
                                orderDetails.id,
                                orderDetails.order_date
                              )}
                            >
                              {" "}
                              {orderDetails.order_status != 5 &&
                              orderDetails.order_status != 6 &&
                              mindiff <= totalCancelationMinutes &&
                              orderDetails.order_status != 4 ? (
                                <p class="cancel_txt">Cancel Order</p>
                              ) : (
                                ""
                              )}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        });
        this.setState({
          orderDetails: orderDetails,
        });
      }
    });
  };

  getOrderDetails = (patientId) => {
    //  patientId = 7;
    Httpconfig.httptokenget(
      Constant.siteurl +
        "api/OM/orderProcess/getPatientOrderDetails/" +
        patientId
    ).then((response) => {
      if (response.data.status == "200" && response.data.error == false) {
        // console.clear();
        //console.log(response);
        this.setState({ completeOrderDate: response.data.data });
        //  console.log(response.data.data);
        const orderDetailsView = response.data.data.map((orderDetails, num) => {
          let orderItemsLength = orderDetails.order_processing_tbls.length;
          let retailerCurrency = "";
          if (orderDetails.retailer_registration_tbl) {
            retailerCurrency = orderDetails.retailer_registration_tbl.currency;
          }
          let total = "";

          // var total_amount = 0;
          // if (orderItemsLength > 0) {
          //   orderDetails.order_processing_tbls.forEach((arg) => {
          //     total_amount += parseFloat(arg.amount);
          //   });
          // }
          // total_amount = total_amount.toFixed(2);

          let orderDate = "N/A";
          let userOrderDate = "N/A";
          let expectedDelivery = "N/A";
          orderDate = orderDetails.order_date;
          if (orderItemsLength > 0) {
            // orderDate = orderDetails.order_invoice_tbls[0].order_date;
            let newdate = orderDate
              .split("-")
              .reverse()
              .join("-");
            // userOrderDate = moment(newdate, "DD-MM-YYYY").format('LL');

            // userOrderDate = new Date(newdate[0], newdate[1] - 1, newdate[2]).toGMTString();
          }
          userOrderDate = moment(orderDate).format("dddd, MMMM Do YYYY");
          // alert("Order Date "+orderDetails.order_date);
          let isRetailerData = "";
          if (orderDetails.retailer_registration_tbl) {
            isRetailerData = Object.keys(orderDetails.retailer_registration_tbl)
              .length;
            if (isRetailerData > 0) {
              let slabDate =
                orderDetails.retailer_registration_tbl.set_delivery_days;
              if (slabDate) {
                // let orderDate = moment(orderDate).format("YYYY-MM-DD");
                var nowPlusOneDay = moment(orderDetails.order_date).add(
                  "days",
                  slabDate
                );
                expectedDelivery = nowPlusOneDay.format("YYYY-MM-DD");
              }
              expectedDelivery = moment(expectedDelivery).format(
                "dddd, MMMM Do YYYY"
              );
            }
          }

          let progressBar = "";
          if (orderDetails.order_status === 1) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">2</a> <p class="p_light">Prescription Verified </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">3</a><p class="p_light">Processed </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">4</a><p class="p_light">Shipped</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">5</a><p class="p_light">Delivered</p></div></div>';
          } else if (orderDetails.order_status === 2) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Prescription Verified </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Processed </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">3</a><p class="p_light">Shipped</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">4</a><p class="p_light">Delivered</p></div></div>';
          } else if (orderDetails.order_status === 3) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Prescription Verified </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Processed </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle"></a><p class="p_light">Shipped</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle">4</a><p class="p_light">Delivered</p></div></div>';
          } else if (orderDetails.order_status === 4) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Prescription Verified </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Processed </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Shipped</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-default btn-circle"></a><p class="p_light">Delivered</p></div></div>';
          } else if (orderDetails.order_status === 5) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Prescription Verified </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Processed </p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Shipped</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Delivered</p></div></div>';
          } else if (orderDetails.order_status === 6) {
            progressBar +=
              '<div class="stepwizard-row setup-panel"><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_dark">Order Placed</p></div><div class="stepwizard-step"><a href="javascript:void(0)" type="" class="btn btn-primary btn-circle"><img src="../images/patient/img/Patient Intake Process/tickmark.svg" /></a><p class="p_light">Cancelled </p></div></div>';
          }

          total = parseFloat(orderDetails.payable_amount)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");

          return (
            <div class="my_order_box">
              <div class="order_box_head">
                <div class="presc_img">
                  {orderDetails.invoice ? (
                    <a
                      href={
                        orderDetails.invoice
                          ? Constant.imgurl + orderDetails.invoice
                          : ""
                      }
                      target="_blank"
                    >
                      <img src="../images/patient/img/Ordermedicine/pdf.svg" />
                    </a>
                  ) : (
                    ""
                  )}
                </div>
                <div class="presc_det">
                  <h2>
                    Order ID: <span>{orderDetails.id}</span>
                  </h2>
                  <h2>
                    Order Date: <span>{userOrderDate}</span>
                  </h2>
                </div>
                {orderDetails.order_status == 1 ? (
                  <p class="pending_btns verify_btn">
                    Prescription verification pending..
                  </p>
                ) : (
                  ""
                )}
                {orderDetails.order_status == 2 ? (
                  <p class="verify_btn">Prescription verified</p>
                ) : (
                  ""
                )}
                {orderDetails.order_status == 3 ? (
                  <p class="verify_btn">Processed</p>
                ) : (
                  ""
                )}
                {orderDetails.order_status == 4 ? (
                  <p class="verify_btn">Shipped</p>
                ) : (
                  ""
                )}
                {orderDetails.order_status == 5 ? (
                  <p class="verify_btn">Delivered</p>
                ) : (
                  ""
                )}
                {orderDetails.order_status == 6 &&
                orderDetails.refund_status == 6 ? (
                  <p class="pending_btns verify_btn">
                    Cancelled <br />
                    Refund Queued For Processing..
                  </p>
                ) : orderDetails.order_status == 6 &&
                  orderDetails.refund_status == 7 ? (
                  <p class="pending_btns verify_btn">
                    Cancelled <br />
                    Amount Refunded
                  </p>
                ) : orderDetails.order_status == 6 ? (
                  <p class="pending_btns verify_btn">Cancelled</p>
                ) : (
                  ""
                )}
                {/* {orderDetails.order_status!=5 ?
                orderDetails.invoice ? (
                  <p class="verify_btn">Invoice Generated</p>
                ) : (
                  <p class="verify_btn">Prescription verification pending..</p>
                )
                : <p class="verify_btn">Cancelled</p>
              } */}
                {/* Prescription verification pending */}
              </div>
              <div class="expect_delivery">
                <h3>Expected delivery by {expectedDelivery}</h3>
                <h6>
                  You will received an invoice with order details after verified
                  the prescription by our pharmacy
                </h6>
                <div class="delivery_list">
                  <div class="item_amnt">
                    <p>{orderItemsLength} items</p>
                    <h2>
                      {retailerCurrency} {total}
                    </h2>
                  </div>

                  <div class="item_flow">
                    <div class="stepwizard">
                      <div dangerouslySetInnerHTML={{ __html: progressBar }} />
                    </div>
                  </div>
                  <div class="view_det_sec">
                    <div class="view_details_btn">
                      <a
                        orderId={orderDetails.id}
                        retailerId={orderDetails.retailer_id}
                        href="javascript:void(0);"
                        onClick={this.getCompleteOrderDetails.bind(this)}
                      >
                        <p>view details </p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        });

        this.setState({
          orderDetailsView: orderDetailsView,
        });
      }
    });
  };

  // getFiles(files) {
  //   this.setState({ files: files });
  //   // console.log(this.state.files[0].base64);
  //   // console.log(this.state.files);
  //   //alert(this.state.files[0].base64);
  //   let patientId = this.state.patientId;
  //   let patientProfileImage = this.state.files[0].base64;
  //   this.state.patientProfileImage = patientProfileImage;
  //   this.forceUpdate();
  //   Httpconfig.httptokenput(
  //     Constant.siteurl + "api/Users/uploadimages/" + patientId,
  //     {
  //       profile_pic: this.state.files[0].base64,
  //     }
  //   )
  //     .then((response) => {
  //       toast.success("👌 Profile Image Updated Successfully", {
  //         position: "bottom-center",
  //       });
  //     })
  //     .catch((error) => {
  //       this.props.history.push("/patienthealthprofile");
  //       console.log(error);
  //       toast.error(error);
  //     });
  // }

  //  Replaces one specific prescription. The pharmacy asked for this document
  //  by name, so the upload says which document it is answering - the server
  //  then swaps it into the same slot instead of adding a third file, and
  //  "Prescription 2" keeps meaning the same thing on both sides.
  replacePrescription = (documentUrl, files) => {
    const file = Array.isArray(files) ? files[0] : files;

    if (!file || !file.base64) {
      toast.error("Could not read that file, please try again");
      return;
    }
    if (file.type != "image/png" && file.type != "image/jpeg") {
      toast.error("Upload files Jpeg / Png formate only!");
      return;
    }

    const orderData =
      this.state.completeOrderDate && this.state.completeOrderDate[0]
        ? this.state.completeOrderDate[0]
        : null;

    const data = {
      patient_id: this.state.patientId,
      cart_id: this.state.cartId,
      medicaldoc_pic: [
        {
          name: file.name,
          base64: file.base64,
          type: file.type,
          size: file.size,
        },
      ],
      //  The one field that makes this a replacement rather than an addition.
      replace_document: documentUrl,
      orderId: this.state.selectedOrderId,
      retailerEmail:
        orderData && orderData.retailer_registration_tbl
          ? orderData.retailer_registration_tbl.email
          : "",
      retailerName:
        orderData && orderData.retailer_registration_tbl
          ? orderData.retailer_registration_tbl.storename
          : "",
      customerName:
        orderData && orderData.patient_tbl ? orderData.patient_tbl.name : "",
    };

    Httpconfig.httptokenpost(
      Constant.siteurl + "api/OM/Cart/prescriptionImage",
      data
    )
      .then((response) => {
        if (response.data.status == "200" && response.data.error == false) {
          toast.success(response.data.message);
          this.getCompleteOrderDetailsReload();
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.error("Unable to upload prescription, please try again");
      });
  };

  //  Tells the customer exactly which prescription the pharmacy rejected and
  //  why, with the re-upload control on that prescription rather than one
  //  shared button at the bottom of the page.
  renderReuploadNotice = () => {
    if (!this.state.reuploadRequired) return "";

    const prescriptions = this.state.orderPrescriptions || [];
    const flagged = prescriptions.filter((p) => p.reupload_required);

    return (
      <div
        style={{
          border: "1px solid #dc3545",
          borderRadius: 6,
          background: "#fff5f5",
          padding: 12,
          marginBottom: 12,
        }}
      >
        <h6 style={{ color: "#dc3545", fontWeight: "bold", marginBottom: 8 }}>
          {flagged.length
            ? "The pharmacy needs " +
              flagged.map((p) => p.label).join(" and ") +
              " replaced"
            : "The pharmacy has asked for a new prescription"}
        </h6>

        {/*  No flagged document means an order-level request - nothing uploaded
            yet, or none of the files usable - so the reason is all there is to
            show and the existing Upload control below handles it. */}
        {flagged.length ? (
          flagged.map((p) => (
            <div
              key={p.url || p.index}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                padding: "8px 0",
                borderTop: "1px solid #f1c9c9",
              }}
            >
              <a href={p.url || "#"} target="_blank" rel="noopener noreferrer">
                <img
                  src={p.url}
                  alt={p.label}
                  style={{
                    width: 56,
                    height: 56,
                    objectFit: "cover",
                    borderRadius: 4,
                    border: "1px solid #dee2e6",
                  }}
                />
              </a>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: "bold", fontSize: 13 }}>{p.label}</div>
                <div style={{ fontSize: 12, color: "#dc3545" }}>
                  {p.reason || "Please upload a clearer copy"}
                </div>
              </div>
              <div className="custom-file-upload">
                <label style={{ marginBottom: 0, whiteSpace: "nowrap" }}>
                  Replace this one
                  <FileBase64
                    multiple={false}
                    onDone={(files) => this.replacePrescription(p.url, files)}
                  />
                </label>
              </div>
            </div>
          ))
        ) : (
          <p style={{ fontSize: 12, marginBottom: 0 }}>
            {this.state.reuploadReason
              ? this.state.reuploadReason
              : "Please upload a valid prescription for this order."}
          </p>
        )}
      </div>
    );
  };

  getFiles(files) {
    let patientId = this.state.patientId;
    let cartId = this.state.cartId;
    let uploadedFiles = [];
    let medicaldoc_pic = [];
    let data = "";

    var objLen = 0;
    if (this.state.files) {
      objLen = Object.keys(this.state.files).length;
    }
    if (objLen > 0) {
      this.state.files = files.concat(this.state.files); //[...files, ...this.state.files];
    } else {
      this.setState({ files: files });
    }
    uploadedFiles = this.state.files;
    this.forceUpdate();
    if (uploadedFiles.length <= 5) {
      var fileFormate = false;
      for (let i = 0; i <= uploadedFiles.length - 1; i++) {
        if (uploadedFiles[i].type) {
          if (
            uploadedFiles[i].type == "image/png" ||
            uploadedFiles[i].type == "image/jpeg"
          ) {
            fileFormate = true;
          } else {
            fileFormate = false;
            break;
          }
        }
      }
      // uploadedFiles.map((item) => {
      //   if (item.type) {
      //     if (item.type == "image/png" || item.type == "image/jpeg") {
      //       console.log("Type", item.type);
      //       fileFormate = true;
      //     } else {
      //       fileFormate = false;
      //       return;
      //     }
      //   }
      // });

      if (fileFormate) {
        $(".delivery_upload_img").empty();
        for (var cnt = 0; cnt < uploadedFiles.length; cnt++) {
          if (uploadedFiles[cnt].base64) {
            // $(".delivery_upload_img").append(
            //   "<img src=" + uploadedFiles[cnt].base64 + "></img>"
            // );
            medicaldoc_pic.push({
              name: uploadedFiles[cnt].name,
              base64: uploadedFiles[cnt].base64,
              type: uploadedFiles[cnt].type,
              size: uploadedFiles[cnt].size,
            });
          } else {
            // $(".delivery_upload_img").append(
            //   "<img src=" +
            //     Constant.imgurl +
            //     "" +
            //     uploadedFiles[cnt] +
            //     "></img>"
            // );
            medicaldoc_pic.push({
              imgUrl: uploadedFiles[cnt],
            });
          }
        }

        data = {
          patient_id: patientId,
          cart_id: cartId,
          medicaldoc_pic: medicaldoc_pic,
          retailerEmail: this.state.completeOrderDate[0]
            .retailer_registration_tbl.email,
          retailerName: this.state.completeOrderDate[0]
            .retailer_registration_tbl.storename,
          orderId: this.state.selectedOrderId,
          customerName: this.state.completeOrderDate[0].patient_tbl.name,
        };

        Httpconfig.httptokenpost(
          Constant.siteurl + "api/OM/Cart/prescriptionImage",
          data
        )
          .then((response) => {
            if (response.data.status == "200" && response.data.error == false) {
              //this.renderingUploadedImgs();
              this.getCompleteOrderDetailsReload();
              toast.success(response.data.message);
            }
          })
          .catch((error) => {
            toast.error(error);
          });
      } else {
        toast.error("Upload files Jpeg / Png formate only!");
      }
    } else {
      toast.error("More than 5 Files not allowed!");
    }
  }

  ImageClick = (event) => {
    var array = this.state.files;
    var foundValue = array.filter((obj) => obj.name != event.target.id);
    this.setState({ files: foundValue });
  };
  ImageZoomClick = (event) => {
    this.setState({
      zoomimage: event.currentTarget.src,
    });
  };
  renderingUploadedImgs() {
    var documentsRelated = [];
    if (this.state.files) {
      let imageArray = this.state.files;
      this.state.uploadedImages = [];
      // alert(imageArray.length);
      if (imageArray.length > 0) {
        for (var i = 0; i < imageArray.length; i++) {
          let img = imageArray[i].name.split(".");
          let imgName = img[0];
          let imageName = imageArray[i].name;
          let imagebase64 = imageArray[i].base64;
          let imageType = imageArray[i].type;
          let imageSize = imageArray[i].size;
          let imageId = imageArray[i];

          documentsRelated.push(
            <div class={"upload_presc_img " + imgName}>
              <a
                href="#"
                class="thumbnail"
                data-toggle="modal"
                data-target="#lightbox"
              >
                <img
                  src={imagebase64}
                  id={imgName}
                  value={imageName}
                  alt={imageName}
                  name={imageName}
                  onClick={this.ImageZoomClick.bind(this)}
                />
              </a>
              <div class="upload_top_img">
                <a
                  href="#"
                  class="thumbnail"
                  data-toggle="modal"
                  data-target="#lightbox"
                ></a>
                <img
                  class="delete_img"
                  id={"img_" + imageArray[i].name}
                  onClick={this.removeImageOnClick}
                  src="../images/patient/img/Ordermedicine/delete.png"
                />
              </div>
            </div>
          );
        }
        // alert(documentsRelated);
        $(".delivery_upload_img").after(documentsRelated);
      }
      this.setState({ uploadedImages: [] });
      //this.state.uploadedImages = documentsRelated;

      //this.forceUpdate();
    }
  }
  removeImageOnClick = (event) => {
    let imageName = event.currentTarget.id.replace(
      "/uploads/patient/cart_prescriptions/",
      ""
    );
    let data = {
      image_name: imageName,
      cart_id: this.state.cartId,
    };

    Httpconfig.httptokenpost(
      Constant.siteurl + "api/OM/Cart/deleteCartPrescriptionImageUploaded",
      data
    )
      .then((response) => {
        if (response.data.status == "200" && response.data.error == false) {
          this.getCompleteOrderDetailsReload();
          toast.success(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  render() {
    return (
      <main id="main_ord_nav">
        {/* ja-jp */}
        {/* en-us */}
        {/* de-de */}
        {/* fr-ca */}
        <PatientHeader onSelectLanguage={this.handleLanguage} />
        <I18nPropvider locale={this.state.Language}>
          {this.state.is_view_profile == true ? (
            <section id="order_profile">
              <div class="pro_section">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                      <PatientSideMenu />
                      {/* <div class="profile_menu_sec1" id="pro_menu">
                        <div class="profile_box">
                          {this.state.patientProfileImage != "" ? (
                            <img src={this.state.patientProfileImage} />
                          ) : this.state.PatientGender == "Male" ? (
                            <img src="../images/patient/img/Profile/Male_patient.svg" />
                          ) : (
                            <img src="../images/patient/img/Profile/Female_patient.svg" />
                          )}
                          <a href="javascript:void(0)">
                            {" "}
                            <h2 class="edit_avtar">
                              <div class="input-group">
                                <span class="input-group-btn">
                                  <span class="btn btn-default btn-file">
                                    <img
                                      src="../images/patient/img/Profile/edit.svg"
                                      onClick={this.uploadProfilePic}
                                    />
                                    <FileBase64
                                      multiple={true}
                                      onDone={this.getFiles.bind(this)}
                                    />
                                  </span>
                                </span>
                              </div>
                            </h2>
                          </a>
                          <div class="profile_name_sec">
                            <p class="hello_word">{translate("Hello!")}</p>
                            <p class="doc_name">{this.state.name ? this.state.name.charAt(0).toUpperCase() +this.state.name.slice(1):""}</p>
                          </div>
                        </div>
                        <ul class="profile-menu-ul-1">
            <li class=""><a href="/Patientdashboard"><img src="../images/patient/img/Ordermedicine/myAppointment.svg" />{translate('My Appointment')} <span class="right_arrow"><img  src="../images/patient/img/Ordermedicine/rightIcon.svg" /></span></a></li>
            <li class="profile_li">
                          <a href="/patient/myOrders">
                            <img src="../images/patient/img/Ordermedicine/MyOrder.svg"/>
                            {translate("My Orders")}
                            <span class="right_arrow"><img  src="../images/patient/img/Ordermedicine/rightIcon.svg" /></span>
                          </a>
                        </li>
                        <li class=""><a href="#"><img src="../images/patient/img/Ordermedicine/MyProfile.svg" />My Saved Medicine  <span class="right_arrow"><img  src="../images/patient/img/Ordermedicine/rightIcon.svg" /></span></a></li>
            <li class="" onClick={this.addPatient}><a href="/patient/Patientprofile"><img src="../images/patient/img/Ordermedicine/MyProfile.svg" />{translate('My Profile')}  <span class="right_arrow"><img  src="../images/patient/img/Ordermedicine/rightIcon.svg" /></span></a></li>
          
          
                        <li class="">
                          <a href="/patient/manageAddress">
                            <img src="../images/patient/img/Ordermedicine/locationicon.svg" />
                            {translate("Manage Address")}
                            <span class="right_arrow"><img  src="../images/patient/img/Ordermedicine/rightIcon.svg" /></span>
                          </a>
                        </li>
                        <h2>Others</h2>
            <li class=""><a href="#"><img src="../images/patient/img/Ordermedicine/PrivacyPolicy.svg" />{translate('Privacy Policy')}
            <span class="right_arrow"><img  src="../images/patient/img/Ordermedicine/rightIcon.svg" /></span>
            </a></li>
            <li class=""><a href="#"><img src="../images/patient/img/Ordermedicine/T&C.svg" />{translate('Terms & Conditions')}
            <span class="right_arrow"><img  src="../images/patient/img/Ordermedicine/rightIcon.svg" /></span>
            </a></li>
            
            
            </ul>
                      </div> */}
                    </div>
                    {/* Side Menu Ends here */}

                    {/* Starts First Div 8 */}
                    <div
                      class="col-lg-9 col-md-12 col-sm-12 col-xs-12"
                      id="first_set"
                    >
                      <div class="my_orders">
                        <div class="order_head">
                          <h2>My Orders</h2>
                          <h5>Upcoming</h5>
                        </div>
                        <div class="my_order_list">
                          {/* Static Box Starts from here */}
                          {this.state.orderDetailsView}

                          {/* Static Block Ends */}
                        </div>
                      </div>
                    </div>
                    {/* Ends div 8 */}
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <React.Fragment>
              {" "}
              <section id="order_view_det">
                <div class="pro_section">
                  <div class="container">
                    <div class="row">
                      {/* <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                        <div class="profile_menu_sec" id="pro_menu">
                          <div class="profile_box">
                            {this.state.patientProfileImage != "" ? (
                              <img src={this.state.patientProfileImage} />
                            ) : this.state.PatientGender == "Male" ? (
                              <img src="../images/patient/img/Profile/Male_patient.svg" />
                            ) : (
                              <img src="../images/patient/img/Profile/Female_patient.svg" />
                            )}
                            <a href="javascript:void(0)">
                              {" "}
                              <h2 class="edit_avtar">
                                <div class="input-group">
                                  <span class="input-group-btn">
                                    <span class="btn btn-default btn-file">
                                      <img
                                        src="../images/patient/img/Profile/edit.svg"
                                        onClick={this.uploadProfilePic}
                                      />
                                      <FileBase64
                                        multiple={true}
                                        onDone={this.getFiles.bind(this)}
                                      />
                                    </span>
                                  </span>
                                </div>
                              </h2>
                            </a>
                            <div class="profile_name_sec">
                              <p class="hello_word">{translate("Hello!")}</p>
                              <p class="doc_name">{this.state.name}</p>
                            </div>
                          </div>

                          <ul class="profile-menu-ul-1">
                            <li class="profile_li">
                              <a href="/Patientdashboard">
                                <img src="../images/patient/img/Profile/My Appointment.svg" />
                                {translate("My Appointment")}
                              </a>
                            </li>
                            <li class="" onClick={this.addPatient}>
                              <a href="javascript:void(0)">
                                <img src="../images/patient/img/Profile/My Profile.svg" />
                                {translate("My Profile")}
                              </a>
                            </li>
                            <li class="profile_li">
                              <a href="/patient/myOrders">
                                <img src="../images/patient/img/Profile/My Appointment.svg" />
                                {translate("My Orders")}
                              </a>
                            </li>
                            <li class="profile_li">
                              <a href="/patient/manageAddress">
                                <img src="../images/patient/img/Profile/My Appointment.svg" />
                                {translate("Manage Address")}
                              </a>
                            </li>
                            <li class="">
                              <a href="javascript:void(0)">
                                <img src="../images/patient/img/Profile/Privacy Policy.svg" />
                                {translate("Privacy Policy")}
                              </a>
                            </li>
                            <li class="">
                              <a href="javascript:void(0)">
                                <img src="../images/patient/img/Profile/Terms & Conditions.svg" />
                                {translate("Terms & Conditions")}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div> */}
                      {/* Side Menu Ends here */}
                      <div
                        class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                        id="second_set"
                      >
                        {/* <h3> Hai Avinash Iam second Div </h3> */}
                        {this.state.orderDetails}
                        {/* {this.state.uploadedImages} */}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </React.Fragment>
          )}
          <PatientFooter />
        </I18nPropvider>
      </main>
    );
  }
}
